import React from 'react';
import { Clock } from 'lucide-react';
import { iconOn } from '../lib/leaveColour';
import { DayNumberOver } from './DayMark';

/**
 * A TIMED booking (10:00-12:00) drawn inside a day cell: a pale tint of the leave colour,
 * a band from the bottom as tall as the share of their day, and a clock (C16 — Rob chose
 * C on 23/10/2026, and Q6 a: the wallchart and both year planners draw it the same way).
 *
 * Fills its parent, which must be `position: relative` with `overflow: hidden`. `share`
 * comes from `dayShare()` in lib/bookingTime, so it is never 0 and never a full day.
 */
const TimedDayFill = ({ color, share, pending = false, iconClass = 'w-3 h-3', n = null }) => (
  <>
    <div className="absolute inset-0" style={{ backgroundColor: `${color || '#f59e0b'}1f` }} />
    <div
      className={`absolute inset-x-0 bottom-0 flex items-end justify-center ${pending ? 'opacity-60' : ''}`}
      style={{ height: `${Math.round(share * 100)}%`, backgroundColor: color || '#f59e0b' }}
    >
      <Clock className={`hh-day-icon ${iconClass} ${iconOn(color || '#f59e0b')} mb-px`} />
    </div>
    {pending && (
      <div className="absolute inset-0 border border-dashed rounded-sm" style={{ borderColor: color || '#f59e0b' }} />
    )}
    {/* The date while the pointer is on the day (Rob, 03/11/2026) — over the pale part AND the band. */}
    {n !== null && <DayNumberOver n={n} numClass="text-foreground hh-day-num-halo" />}
  </>
);

export default TimedDayFill;
